import React from 'react';
import styled from 'styled-components';

import { Questions } from '@components/Questions';
import { Points } from '@styles';

export const FAQ = ({ data }) => {
  const questionData = data.map((item) => ({
    question: item.form_data.question,
    answer: item.form_data.answer,
  }));

  return (
    <QuestionContainer
      questionData={questionData}
      titleTranslationKey={'site.home.faq.title'}
      descriptionTranslationKey={'site.home.faq.description'}
    />
  );
};

const QuestionContainer = styled(Questions)`
  && {
    padding-top: 0;

    @media ${Points.tablet_landscape} {
      width: 100%;
      max-width: 1024px;
      margin: 0 auto;
      padding: 0px 28px 40px;
    }

    @media ${Points.laptop_wide} {
      width: 100%;
      max-width: 1600px;
      margin: 0 auto;
      padding: 0px 80px 120px;
    }

    @media ${Points.fullhd} {
      width: 100%;
      max-width: 1900px;
      margin: 0 auto;
      padding: 0px 160px 80px;

      & > div:nth-child(2) {
        width: 1095px;
      }
    }
  }
`;
